import React, {
    useState,
    useRef,
} from 'react'
import {
    ToolbarButton,
    ExportCsv,
    ExportPrint,
} from '@mui/x-data-grid-pro'
import FileDownloadIcon from '@mui/icons-material/FileDownloadOutlined'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import {
    noop,
} from 'lodash'
import pdfStyles from './ExportToolbarMenuPdf.styles'

type Props = {
    onItemClick?: () => void,
}

const ExportToolbarMenu = ({
    onItemClick = noop,
}: Readonly<Props>) => {
    const [
        exportMenuOpen,
        setExportMenuOpen,
    ] = useState(false)
    const exportMenuTriggerRef = useRef<HTMLButtonElement>(null)

    const handleClose = () => {
        setExportMenuOpen(false)
        onItemClick()
    }

    const handleTriggerClick = () => {
        setExportMenuOpen(true)
    }

    return (
        <>

            <Tooltip title="Export">
                <ToolbarButton
                    ref={exportMenuTriggerRef}
                    onClick={handleTriggerClick}
                    data-testid="export-toolbar-button"
                >
                    <FileDownloadIcon fontSize="small" />
                </ToolbarButton>
            </Tooltip>

            <Menu
                anchorEl={exportMenuTriggerRef.current}
                open={exportMenuOpen}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                data-testid="export-menu"
            >
                <ExportPrint
                    render={<MenuItem />}
                    data-testid="export-menu-print"
                    onClick={handleClose}
                    options={{
                        hideToolbar: true,
                        hideFooter: true,
                        pageStyle: pdfStyles,
                    }}
                >
                    Print
                </ExportPrint>
                <ExportCsv
                    render={<MenuItem />}
                    onClick={handleClose}
                >
                    Download as CSV
                </ExportCsv>
            </Menu>
        </>
    )
}

export default ExportToolbarMenu
